module.exports = __webpack_public_path__ + "img/cover.230c3b75.png";